import React, { useState } from 'react'
import Label from '../../ui/label';
import Input from '../../ui/input';
import Button from '../../ui/button';

import { useTranslation } from 'react-i18next';

export default function ChangePasswordModal({ isOpen, onClose }) {
    const {t} = useTranslation('common');
    const [formData, setFormData] = useState()

    const HandleChange = (value) => {
        const t = useTranslation('common');
        setFormData()
    }

    const closeModal = (refresh=false) => {
        onClose(refresh);
    };

    return (
        <div className=" flex flex-col space-x-6 space-y-6   w-auto m-2 bg-white  max-md:p-3 p-8 rounded-3xl shadow-lg">
            <p className="flex justify-center col-span-2 text-xl  text-[#4C4C66] font-bold mb-4">{t('change_password')}</p>
            {/* form */}
            <div className='flex justify-between '>
                <Label setValue='Old Password' />
                <Input onChange={HandleChange} type='password' />
            </div>
            <div className='flex justify-between '>
                <Label setValue='New Password' />
                <Input onChange={HandleChange} type='password' />
            </div>
            <div className='flex justify-between '>
                <Label setValue='Confirm Password' />
                <Input onChange={HandleChange} type='password' />
            </div>
            <div className='col-span-2 flex justify-center mt-10 space-x-5'>
                <Button type="reset" onClick={closeModal} size="large" color="cancel" >{t('cancel')}</Button>
                <Button
                    type="submit"
                    size="large"
                >{t('change')}</Button>
            </div>
        </div>
    );
}
